import { render, staticRenderFns } from "./SourceTaskDetailView.vue?vue&type=template&id=78331bc6&scoped=true"
import script from "./SourceTaskDetailView.vue?vue&type=script&lang=js"
export * from "./SourceTaskDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78331bc6",
  null
  
)

export default component.exports